<footer
  class="footer-nav"
  [ngClass]="{ 'active': navActive, 'hide-footer': (navBloc.coreNavSubject$ | async).length === 0 }">
  <kp-core-nav
    class="footer-nav-component-container hidden-print"
    [quickActionsOpen]="quickActionsOpen"
    (quickActionsToggled)="quickActionsToggled.emit($event)"></kp-core-nav>
  <kp-copyright class="hidden-screen"></kp-copyright>
</footer>
